const PROP_PREFIX = process.env.VUE_APP_PROP_PREFIX;
const PROP_EXP = 60 * 24 * 60 * 60 * 1000; // 60 dias

export function getStorageData(prop, defaultValue, checkExp = false) {
  try {
    // busca a propriedade com prefixo
    const ls = localStorage.getItem(`${PROP_PREFIX}${prop}`);
    if (ls === null) return defaultValue;

    const json = JSON.parse(ls);
    if (json === null || typeof json !== "object") return defaultValue;

    if (checkExp && "exp" in json && json.exp < Date.now()) return defaultValue;
    return prop in json ? json[prop] : defaultValue;
  } catch (err) {
    console.error(err);
    return defaultValue;
  }
}

export function setStorageData(prop, newData) {
  try {
    const propWithPrefix = `${PROP_PREFIX}${prop}`;
    if (newData === null) {
      localStorage.removeItem(propWithPrefix);
    } else {
      const exp = PROP_EXP + Date.now();
      localStorage.setItem(propWithPrefix, JSON.stringify({ exp, [prop]: newData }));
    }
    return true;
  } catch (err) {
    console.error(err);
    globalThis.window.$log.error("Storage error.", err);
    return false;
  }
}
